import React from 'react'
import clsx from 'clsx'
import styles from './UIGamePlayerInfoSectionImageWithCount.module.scss'
import {ImageURL} from '@colonist/types'

interface UIGamePlayerInfoSectionImageWithCountProps {
    piece: ImageURL
    count: number
    size?: 'md' | 'sm'
}

export const UIGamePlayerInfoSectionImageWithCount = ({
    piece,
    count,
    size = 'md',
}: UIGamePlayerInfoSectionImageWithCountProps) => (
    <div className={styles.container}>
        <img className={styles.image} src={piece} />
        <span className={clsx(styles.count, {
            [styles.sm]: size === 'sm',
        })}>{count}</span>
    </div>
)
